import { fn } from '@ember/helper';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import BasicDropdown from 'ember-basic-dropdown/components/basic-dropdown';
import HeaderSelectorOption from 'garaje/components/header-selector/option';
import UiButton from 'garaje/components/ui-button';
import type { FilterItem } from 'garaje/models/common';

interface HeaderSelectorSignature<T extends Partial<FilterItem>> {
  Args: {
    options: T[];
    onUpdate?: (option: T) => void;
    disabled?: boolean;
  };
}

export default class HeaderSelector<T extends Partial<FilterItem>> extends Component<HeaderSelectorSignature<T>> {
  @action
  toggleHeaders(option: T): void {
    const show = option.show;
    option.show = !show;
    this.args.onUpdate?.(option);
  }

  <template>
    <BasicDropdown @disabled={{@disabled}} as |headerSelector|>
      <headerSelector.Trigger>
        <UiButton
          data-test-header-selector-trigger
          class="ember-power-select-trigger ember-basic-dropdown-trigger mr-2 whitespace-nowrap"
          style="background-image:none; padding-right:12px;"
          disabled={{@disabled}}
        >
          <span class="ember-power-select-selected-item">
            <span data-test-select-option>
              <img src="/assets/images/columns.svg" alt="select columns to show" class="pr-2 self-start" />
            </span>
          </span>
          Columns
          <span class="ember-power-select-status-icon"></span>
        </UiButton>
      </headerSelector.Trigger>
      <headerSelector.Content>
        <div
          style="width:300px"
          class="p-2 pt-0 ember-basic-dropdown-content ember-power-select-dropdown ember-basic-dropdown-content--left ember-basic-dropdown-content--below ember-basic-dropdown--transitioned-in"
        >
          <ul role="listbox" class="ember-power-select-options">
            {{#each @options as |option index|}}
              <HeaderSelectorOption
                @index={{index}}
                @option={{option}}
                @toggleHeadersAction={{fn this.toggleHeaders option}}
              />
            {{/each}}
          </ul>
        </div>
      </headerSelector.Content>
    </BasicDropdown>
  </template>
}
